import React from 'react';
import { graphql } from 'gatsby';

import Seo from "../components/seo/head";
import CustomBlockAssigner from '../components/customer-block-assigner';

const CustomBlockPage = ({ data }) => {
  const { contentfulCustomBlockPage } = data;

  const {
    blocks
  } = contentfulCustomBlockPage;

  return (
    <div className={`${blocks[0]?.internal?.type !== "ContentfulHeroBlock" && "no-hero-page"} page-wrapper`}>
      { blocks && blocks.map((block, index) => {
        return(
          <CustomBlockAssigner
            block={block}
            blockIndex={index}
            key={`page-custom-block-${index}`}
          />
        )
      })
      }
    </div>
  )
}

export const Head = ({data, location}) => (
  <Seo
    location={location} {...data.contentfulCustomBlockPage.seo} 
  />
)

export default CustomBlockPage;

export const PageQuery = graphql`
  query ($id: String!) {
    contentfulCustomBlockPage(id: {eq: $id}) {
      title
      blocks {
        ...contentBlockFields
        ...iframeBlockFields
        ... on ContentfulFile {
          title
          internal {
            type
          }
          files {
            title
            url
          }
        }
        ... on ContentfulGrid {
          internal {
            type
          }
          gridItem {
            title
            slug
            updatedAt(formatString: "DD MMMM, YYYY")
            excerpt {
              excerpt
            }
            internal {
              type
            }
            productImageLabel {
              gatsbyImageData(
                width: 1024
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
              title
            }
            hideProductImageLabelOnDirectoryPage
            featuredImages {
              gatsbyImageData(
                width: 1024
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
              title
            }
          }
        }
        ...heroBlockFields
        ... on ContentfulImageBanner {
          title
          buttonText
          buttonLink
          internal {
            type
          }
          image {
            gatsbyImageData(
              width: 1024
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
            title
          }
        }
        ...buttonListBlockFields
        ...imageBlockFields
        ...imageTextBlockFields
        ... on ContentfulSlider {
          internal {
            type
          }
          slide {
            ... on ContentfulBlog {
              date(formatString: "DD MMMM, YYYY")
              featuredImage {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
              title
              slug
              internal {
                type
              }
            }
            ... on ContentfulTraining {
              featuredImage {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
              title
              slug
              internal {
                type
              }
            }
            ... on ContentfulArticle {
              featuredImage {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
              title
              slug
              internal {
                type
              }
            }
          }
        }
        ... on ContentfulCardContainer {
          title
          cards {
            backgroundColour
            textColour
            title
            imageMaxWidthPx
            url
            text {
              raw
            }
            image {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          internal {
            type
          }
        }
      }
      seo {
        metaTitle
        metaDescription {
          metaDescription
        }
        robotsMetaTag
      }
    }
  }
`